import { Overlay, Popover } from 'react-bootstrap';
import type { OverlayProps as BootstrapOverlayProps } from 'react-bootstrap';
import classNames from 'classnames';
import { nanoid } from 'nanoid';

import styles from './_index.module.scss';

export interface OverlayPopoverProps extends Omit<BootstrapOverlayProps, 'children'> {
  children: React.ReactNode;
  className?: string;
  container?: HTMLElement;
  'data-testid'?: string;
  hasArrow?: boolean;
  header?: React.ReactNode;
  isActive?: boolean;
  onHide?: () => void;
}

const OverlayPopover = ({
  children,
  className,
  container,
  'data-testid': dataTestId = 'overlay-popover',
  hasArrow = true,
  header,
  isActive,
  onHide,
  placement = 'bottom',
  target,
}: OverlayPopoverProps) => {
  return (
    <Overlay
      container={container}
      containerPadding={20}
      onHide={onHide}
      placement={placement}
      popperConfig={{
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 10],
            },
          },
        ],
      }}
      rootClose
      show={isActive}
      target={target}
    >
      <Popover
        className={classNames(styles['overlay-popover'], className, {
          [styles['has-arrow']]: hasArrow,
        })}
        data-testid={dataTestId}
        id={nanoid()}
      >
        {header && <h4>{header}</h4>}
        {children}
      </Popover>
    </Overlay>
  );
};

export default OverlayPopover;
